export const MIN_PROXY_PORT = 1;
export const MAX_PROXY_PORT = 65535;

export const DEFAULT_HTTP_PROXY_PORT = 8080;
export const DEFAULT_HTTPS_PROXY_PORT = 8443;
export const DEFAULT_UPSTREAM_PROXY_PORT = 8888;
